// Remembers which option a landing-page visitor picked ("human" / "ai") so that
// after login we can route them straight into that flow. sessionStorage primary,
// localStorage fallback. All operations fail silently.
const KEY = "maziara_intent";
const MAX_AGE_MS = 30 * 60 * 1000;

export function saveIntent(type) {
  try {
    const value = JSON.stringify({ type, ts: Date.now() });
    try { sessionStorage.setItem(KEY, value); } catch { /* storage unavailable */ }
    try { localStorage.setItem(KEY, value); } catch { /* storage unavailable */ }
  } catch { /* ignore */ }
}

export function readIntent() {
  try {
    let raw = null;
    try { raw = sessionStorage.getItem(KEY); } catch { /* ignore */ }
    if (!raw) { try { raw = localStorage.getItem(KEY); } catch { /* ignore */ } }
    if (!raw) return null;
    clearIntent();
    const data = JSON.parse(raw);
    const valid =
      (data?.type === "human" || data?.type === "ai") &&
      typeof data?.ts === "number" &&
      Date.now() - data.ts < MAX_AGE_MS;
    return valid ? data.type : null;
  } catch {
    return null;
  }
}

export function clearIntent() {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
